import { render } from "./Layout.vue?vue&type=template&id=2a27efcc&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=2a27efcc&lang=scss&scoped=true"
import "../../styles/notification.scss?vue&type=style&index=1&id=2a27efcc&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a27efcc"]])

export default __exports__